"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Checkmark;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// displays a tick or cross based on the boolean value passed

function Checkmark({
  checked,
  className
}) {
  return /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, checked ? '✔' : '✘');
}